import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const unitTypesAdapter = createEntityAdapter({});

const initialState = unitTypesAdapter.getInitialState();

export const unitTypesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUnitTypes: builder.query({
      query: (propertyType) => `/unitTypes?propertyType=${propertyType}`,
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      // keepUnusedDataFor: 5,
      transformResponse: (responseData) => {
        const loadedUnitTypes = responseData.map((unitType) => {
          unitType.id = unitType._id;
          return unitType;
        });
        return unitTypesAdapter.setAll(initialState, loadedUnitTypes);
      },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "UnitType", id: "LIST" },
            ...result.ids.map((id) => ({ type: "UnitType", id })),
          ];
        } else return [{ type: "UnitType", id: "LIST" }];
      },
    }),
    addNewUnitType: builder.mutation({
      query: (initialUnitTypeData) => ({
        url: "/unitTypes",
        method: "POST",
        body: {
          ...initialUnitTypeData,
        },
      }),
      invalidatesTags: [{ type: "UnitType", id: "LIST" }],
    }),
    updateUnitType: builder.mutation({
      query: (initialUnitTypeData) => ({
        url: "/unitTypes",
        method: "PATCH",
        body: {
          ...initialUnitTypeData,
        },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "UnitType", id: arg.id },
      ],
    }),
    deleteUnitType: builder.mutation({
      query: ({ id }) => ({
        url: `/unitTypes`,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "UnitType", id: arg.id },
      ],
    }),
    getUnitTypesByProperty: builder.query({
      query: (propertyId) => `/unitTypes/byProperty?propertyId=${propertyId}`,
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      // keepUnusedDataFor: 5,
      transformResponse: (responseData) => {
        const loadedUnitTypes = responseData.map((unitType) => {
          unitType.id = unitType._id;
          return unitType;
        });
        return unitTypesAdapter.setAll(initialState, loadedUnitTypes);
      },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "UnitType", id: "LIST" },
            ...result.ids.map((id) => ({ type: "UnitType", id })),
          ];
        } else return [{ type: "UnitType", id: "LIST" }];
      },
    }),
  }),
});

export const {
  useGetUnitTypesQuery,
  useAddNewUnitTypeMutation,
  useUpdateUnitTypeMutation,
  useDeleteUnitTypeMutation,
  useGetUnitTypesByPropertyQuery,
} = unitTypesApiSlice;

// returns the query result object
export const selectUnitTypesResult =
  unitTypesApiSlice.endpoints.getUnitTypes.select();

// creates memoized selector
const selectUnitTypesData = createSelector(
  selectUnitTypesResult,
  (unitTypesResult) => unitTypesResult.data // normalized state object with ids & entities
);

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllUnitTypes,
  selectById: selectUnitTypeById,
  selectIds: selectUnitTypeIds,
  // Pass in a selector that returns the unitTypes slice of state
} = unitTypesAdapter.getSelectors(
  (state) => selectUnitTypesData(state) ?? initialState
);
